// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SortLabel--moderator":"fp_a bhv_hm","SortLabel__newFeature":"fp_b bhv_uc bhv_ur"};